import { render, staticRenderFns } from "./ColdChainEditDrawer.vue?vue&type=template&id=65d5ddd5"
import script from "./ColdChainEditDrawer.vue?vue&type=script&lang=js"
export * from "./ColdChainEditDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports